import { SystemLogoRequestPresignedUrlRequestSchema, SystemLogoRequestPresignedUrlResponseSchema, SystemLogoConfirmUploadRequestSchema, SystemLogoConfirmUploadResponseSchema } from './upload-system-logo.schema';
/**
 * Request Presigned URL Endpoint Contract
 * Generates a presigned URL for direct upload to DigitalOcean Spaces
 */ export const systemLogoRequestPresignedUrlContract = {
    method: 'POST',
    path: '/api/v2/upload-system-logo/request-url',
    description: 'Request a presigned URL for system logo upload',
    requestSchema: SystemLogoRequestPresignedUrlRequestSchema,
    responseSchema: SystemLogoRequestPresignedUrlResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized - invalid or missing token',
            404: 'System not found',
            500: 'Internal server error'
        }
    }
};
/**
 * Confirm Upload Endpoint Contract
 * Processes uploaded system logo and updates system
 */ export const systemLogoConfirmUploadContract = {
    method: 'POST',
    path: '/api/v2/upload-system-logo/confirm',
    description: 'Confirm system logo upload and process image',
    requestSchema: SystemLogoConfirmUploadRequestSchema,
    responseSchema: SystemLogoConfirmUploadResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request or invalid image/SVG',
            401: 'Unauthorized - invalid or missing token',
            404: 'System not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=upload-system-logo.contract.js.map